"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateManagerTeamRelationshipRequest = void 0;
var UpdateManagerTeamRelationshipRequest;
(function (UpdateManagerTeamRelationshipRequest) {
    let role;
    (function (role) {
        role["GROWTH"] = "growth";
        role["TEAM_LEADER"] = "teamLeader";
        role["RELATIONSHIPS"] = "relationships";
        role["DEPLOYMENTS"] = "deployments";
        role["MERCH"] = "merch";
        role["TRAINING"] = "training";
    })(role = UpdateManagerTeamRelationshipRequest.role || (UpdateManagerTeamRelationshipRequest.role = {}));
    let teamId;
    (function (teamId) {
        teamId["GROWTH"] = "growth";
        teamId["TEAM_LEADER"] = "teamLeader";
        teamId["RELATIONSHIPS"] = "relationships";
        teamId["DEPLOYMENTS"] = "deployments";
        teamId["MERCH"] = "merch";
        teamId["TRAINING"] = "training";
    })(teamId = UpdateManagerTeamRelationshipRequest.teamId || (UpdateManagerTeamRelationshipRequest.teamId = {}));
})(UpdateManagerTeamRelationshipRequest = exports.UpdateManagerTeamRelationshipRequest || (exports.UpdateManagerTeamRelationshipRequest = {}));
